import "../faixa/faixa.css";
 

export default function Faixa() {
    return (
        <div className="faixa-div">
            <h1 className="texto-div">🔥 Aproveite os melhores ACHADOS de 2026 🔥</h1>
        </div>
    );
}
